













































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
const { AgGridVue } = require('ag-grid-vue');

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchVerificacion } from '../fetchVerificacion';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import Dispositivo from '../Dispositivos/Dispositivo.vue';
import { forEach } from 'lodash';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    AgGridVue,
    FormFieldsContainer,
  },
})
export default class TablaTotalSims extends ComponenteBase {
  @Prop({ default: false }) mostrarDispositivos: boolean;
  @Prop({ required: true }) solicitud: number;
  accionesTotales: PermisoAccion[];
  ordesList: any[] = [];

  funcionalidad: Funcionalidades =
    Funcionalidades.TablaSimsVerificacionBajaCliente;
  usuario = JSON.parse(localStorage.getItem('user')).id;

  inicioTabla() {
    let inicio: any = [];
    this.gridApi.setRowData(inicio);
    this.gridApi.setDomLayout('autoHeight');
  }

  cerrarModal() {
    this.$emit('ocultarDispositivos', false);
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.deselectAll();
  }

  clientes: any = [];
  async getClientes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchVerificacion(
      { solicitud: this.solicitud },
      'conecta_verificacion_baja_cliente/get_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.clientes = data.data.CLIENTES;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.getClientes();
  }

  pagina: number = 1;
  cant_regs_pag: number = 8;

  gridEvent: any = null;
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        this.pagina = Math.ceil(
          event.request.startRow / this.cant_regs_pag + 1
        );
        fetchVerificacion(
          {
            pagina: event.request.startRow,
            cliente: self.formFields.cliente.value,
          },
          'conecta_verificacion_baja_cliente/get_filtered_equipos'
        )
          .then((data: any) => {
            if (data.data.CODIGO_RESPUESTA == '1') {
              self.loadingService.hideLoading();
              event.successCallback(
                data.data.data.LISTA,
                Number(data.data.cant_regs_pag.TOTAL_REGISTROS)
              );
            } else {
              self.loadingService.hideLoading();
              self.$snotify.error(data.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            self.loadingService.hideLoading();
            self.$snotify.error(error, { timeout: 3000 });
          });
      },
    };
  }

  formFields: FormFieldDefMap = {
    cliente: {
      label: 'Cliente',
      value: '',
      id: '',
    },
  };

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  selectedRows: any = [];

  onSelectionChanged(params: any) {}

  // Globales

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;

  loadingService = new LoadingService();

  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('MM-DD-YYYY');
  }

  envioSelected(data: any) {
    this.$emit('dispositivo', data);
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: params => {
          return `<span class="material-icons mt-2">add</span>`;
        },
        cellStyle: { textAlign: 'left' },
        width: 80,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Rut',
        field: 'clienterut',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Cliente',
        field: 'cliente_nombre',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Telco',
        field: 'telconame',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Plan',
        field: 'telcoplanname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'SIM Serie',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'SIM Estado',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Ubicacion',
        field: 'tipoubicaname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Serie',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'IMEI',
        field: 'serieimei',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Patente',
        field: 'patente_vehiculo',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
    ];
    this.gridOptions = {
      localeText: {
        noRowsToShow: 'Por favor seleccione un cliente',
      },
      pagination: true,
      paginationPageSize: this.cant_regs_pag, //Solución Paginación
      cacheBlockSize: this.cant_regs_pag, //Solución Paginación
      paginationAutoPageSize: false,
      columnDefs: this.columnDefs,
      rowModelType: 'serverSide',
      onCellClicked: (params: any) => {
        if (params.event.target.classList.contains('material-icons')) {
          this.envioSelected(params.data);
          // Aquí puedes ejecutar la función que deseas cuando se hace clic en el icono
        }
      },
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  moduloModalCallback(val: boolean) {
    this.showModalEdit = val;
  }
}
